import Team from "../sports/common/team";
import mapRpi from "./rpi-mapper";
import mapDate from "./date-mapper";

const mapColor = (color) => {
    if (!color) {
        return color;
    }

    return color.startsWith("#") ? color : `#${color}`;
};

const mapTeam = (jsonObj, currentObj = {}) => {
    const team = Object.assign(new Team(), currentObj, jsonObj);

    team.dateCreated = mapDate(team.dateCreated);
    team.rpi = mapRpi(team.rpi);
    team.color = currentObj.color || mapColor(jsonObj.color);

    return team;
};

export { mapTeam };
